import {LOGIN, LOGOUT} from '../actions/login'

const initialState = false

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
    switch (action.type) {
        case LOGIN:
            return action.payload
        case LOGOUT:
            return action.payload
        default:
            return state
    }
}
